import { useState } from 'react'
import { Button, CircularProgress } from '@mui/material'
import { Google as GoogleIcon } from '@mui/icons-material'
import { useAuth } from '@/contexts/AuthContext'

interface GoogleLoginButtonProps {
  onSuccess?: () => void
  onError?: (msg: string) => void
  roleId?: number
  fullWidth?: boolean
  size?: 'small' | 'medium' | 'large'
  variant?: 'contained' | 'outlined' | 'text'
  sx?: object
}

export const GoogleLoginButton = ({
  onSuccess,
  onError,
  roleId = 1,
  fullWidth = true,
  size = 'large',
  variant = 'contained',
  sx,
}: GoogleLoginButtonProps) => {
  const { loginWithGoogle } = useAuth()
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = async () => {
    setIsLoading(true)
    try {
      await loginWithGoogle(roleId)
      onSuccess?.()
    } catch (err) {
      const msg = (err as Error).message ?? 'Googleログインに失敗しました'
      onError?.(msg)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Button
      variant={variant}
      fullWidth={fullWidth}
      size={size}
      startIcon={isLoading ? undefined : <GoogleIcon />}
      onClick={handleClick}
      disabled={isLoading}
      sx={sx}
    >
      {isLoading ? <CircularProgress size={22} color="inherit" /> : 'Googleでログイン'}
    </Button>
  )
}
